import { render, staticRenderFns } from "./NewSoftphone.vue?vue&type=template&id=14659ce6&"
import script from "./NewSoftphone.vue?vue&type=script&lang=js&"
export * from "./NewSoftphone.vue?vue&type=script&lang=js&"
import style0 from "./NewSoftphone.vue?vue&type=style&index=0&id=14659ce6&prod&lang=scss&"
import style1 from "./NewSoftphone.vue?vue&type=style&index=1&id=14659ce6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports